import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import firebase from 'firebase/app';
import 'firebase/messaging';

@Injectable({ providedIn: 'root' })
export class FcmService {
  private messaging: firebase.messaging.Messaging | null = null;

  init(): void {
    if (!firebase.apps.length) {
      firebase.initializeApp(environment.firebase);
    }
    try {
      // v8: sprawdź wsparcie zanim użyjesz
      const hasSupportFn = (firebase.messaging as any).isSupported;
      if (typeof hasSupportFn === 'function' && !hasSupportFn()) {
        this.messaging = null; return;
      }
      this.messaging = firebase.messaging();
    } catch {
      this.messaging = null;
    }
  }

  registerServiceWorker(): Promise<void> {
    if (!('serviceWorker' in navigator)) { return Promise.resolve(); }
    return navigator.serviceWorker.register('/firebase-messaging-sw.js').then(function(){}).catch(function(){});
  }

  async getToken(): Promise<string | null> {
    if (!this.messaging) { return null; }
    try {
      const token = await this.messaging.getToken({ vapidKey: environment.vapidPublicKey });
      return token || null;
    } catch (e) {
      console.error('[FCM] getToken error', e);
      return null;
    }
  }

  onMessage(handler: (payload: firebase.messaging.MessagePayload) => void): void {
    if (!this.messaging) { return; }
    this.messaging.onMessage(function(payload) { handler(payload); });
  }
}
